var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserResendInvite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6136_11414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 18C17.3807 18 18.5 16.8807 18.5 15.5C18.5 14.1193 17.3807 13 16 13C14.6193 13 13.5 14.1193 13.5 15.5C13.5 16.8807 14.6193 18 16 18Z",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9873 20.4609C12.3635 19.7199 12.9375 19.0976 13.6458 18.6629C14.354 18.2282 15.1688 17.998 15.9998 17.998C16.8308 17.998 17.6456 18.2282 18.3538 18.6629C19.0621 19.0976 19.6361 19.7199 20.0123 20.4609",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11.5H22",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10V13",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9171 15C22.1281 16.2534 21.9352 17.5413 21.3664 18.6779C20.7976 19.8145 19.8823 20.7409 18.7527 21.3234C17.6231 21.9059 16.3375 22.1142 15.0817 21.9184C13.8259 21.7227 12.6649 21.1328 11.7662 20.2341C10.8674 19.3354 10.2776 18.1743 10.0818 16.9185C9.88603 15.6627 10.0944 14.3772 10.6769 13.2476C11.2594 12.1179 12.1858 11.2026 13.3224 10.6338C14.459 10.0651 15.7469 9.87221 17.0002 10.0832",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6136_11414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserResendInvite);
export default __webpack_public_path__ + "static/media/User_Resend_Invite.c99dcf6ff1b864d1c4be409553081122.svg";
export { ForwardRef as ReactComponent };